export default (name = '') => {
    let [splitName] = name.split(' ')
    return splitName
}
